import component from './ko-KR/component';
import globalHeader from './ko-KR/globalHeader';
import menu from './ko-KR/menu';
import pages from './ko-KR/pages';
import pwa from './ko-KR/pwa';
import settingDrawer from './ko-KR/settingDrawer';
import settings from './ko-KR/settings';
import fixOverlay from './ko-KR/fix_overlay';
import fixOpenapi from './ko-KR/fix_openapi';
import fixAdminMisc from './ko-KR/fix_adminmisc';
import fixBilling from './ko-KR/fix_billing';
import fixComponents from './ko-KR/fix_components';
import fixConsoleMisc from './ko-KR/fix_consolemisc';
import fixGap from './ko-KR/fix_gap';
import fixSystemconfig from './ko-KR/fix_systemconfig';
import fixTenant from './ko-KR/fix_tenant';
import fixVoiceClone from './ko-KR/fix_voiceclone';
import fixTodo from './ko-KR/fix_todo';
import fixLedger from './ko-KR/fix_ledger';


export default {
  'navBar.lang': '??',
  'layout.user.link.help': '???',
  'layout.user.link.privacy': '????',
  'layout.user.link.terms': '??',
  'app.preview.down.block': '? ???? ?? ????? ????',
  'app.welcome.link.fetch-blocks': '?? ?? ????',
  'app.welcome.link.block-list': '?? ?? ??? ???? ?? ???? ??? ??',
  ...fixConsoleMisc,
  ...fixComponents,
  ...fixAdminMisc,
  ...fixBilling,
  ...fixTenant,
  ...fixVoiceClone,
  ...fixGap,
  ...fixSystemconfig,
  ...fixOpenapi,
  ...fixTodo,
  ...fixLedger,
};
